import { decompressFromBase64 } from 'lz-string';
import { pipe } from '../../../shared/misc';

const takeValue = (obj) => obj.value;

export const decompressValue = pipe(takeValue, decompressFromBase64, JSON.parse);
// JSON.parse(decompressFromBase64(takeValue(appConfigApi)))
